window.onload = function () {
	const accordions = document.querySelectorAll(".accordion-item__btn");
	accordions.forEach((item) => {
		item.addEventListener("click", function () {
			this.parentElement.classList.toggle("active");
			let content = this.parentElement.querySelector(
				".accordion-item__content",
			);

			if (content.style.height !== "0px") {
				content.style.height = "0px";
			} else {
				content.style.height = content.scrollHeight + "px";
			}
		});
	});
};
